// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"124":"ce5462e6","146":"cc7edba4","363":"76175524","424":"4590f74c"}[chunkId] + ".chunk.css";
};